<template>
  <div>
    <div class="main-content">
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">ダッシュボード</a>
            </li>
            <router-link tag="li" :to="{ name: 'gates'}">
              <a>ゲート一覧</a>
            </router-link>
            <li class="active">ゲート編集</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
          <div class="checkbox">
            <h3>ゲート編集</h3>
          </div>
        </div><!-- /.page-header -->
        <div class="page-content detail-gate-edit">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="tab-content">
          <div class="alert alert-success" v-if="message_success">
            {{ message_success }}
          </div>
          <div class="alert alert-danger" v-if="message_error">
            {{ message_error }}
          </div>
          <div class="row">
            <div class="col-xs-12">
              <!-- PAGE CONTENT BEGINS -->
              <form class="form-horizontal" role="form">
              <div class="row">
              <div class="col-xs-6">
                <div class="row">
                <div class="profile-user-info profile-user-info-striped">
                  <div class="profile-info-row">
                    <div class="profile-info-name">ゲートID</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.gateId}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">製品ID</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.gateModelId}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">製品名</div>
                    <div class="profile-info-value">
                      <span id="product_error" class="error_m"></span>
                      <select class="form-control" data-placeholder="製品名選択" v-model="gateInfor.gateModelId" @change="getGateModelInforWithGateModeId(gateInfor.gateModelId)">
                        <option v-for="(item, index) in listGateModel" v-bind:value="item.gateModelId" v-bind:key="index">
                          {{item.gateModelName}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">型番</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.gateModelCode}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">アイコンタイプ</div>
                    <div class="profile-info-value">
                      <select class="form-control" v-model="gateInfor.iconType">
                        <option v-for="item in listIconType" v-bind:value="item.value" v-bind:key="item.value">
                          {{item.text}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <!--<div class="profile-info-row">
                    <div class="profile-info-name">メーカー番号</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.makerCode}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">変更有無</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.customizable}}</span>
                    </div>
                  </div>-->
                  <div class="profile-info-row">
                    <div class="profile-info-name">ターゲット動作設定</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.target}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ターゲット動作設定Time</div>
                    <div class="profile-info-value">
                      <input type="number" min="0" max="10000" class="form-control input-sm" v-model="gateInfor.controlTime">
                    </div>
                  </div>
                  <!--<div class="profile-info-row">
                    <div class="profile-info-name">ターゲット動作設定TimeUnit</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.timeUnit}}</span>
                    </div>
                  </div>-->
                  <div class="profile-info-row">
                    <div class="profile-info-name">ゲート名</div>
                    <div class="profile-info-value">
                      <span id="gate_error" class="error_m"></span>
                      <input type="text" class="form-control input-sm" v-model="gateInfor.gateName" id="gatename">
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ゲート動作モード</div>
                    <div class="profile-info-value">
                      <select class="form-control" v-model="gateInfor.isVisitor">
                        <option v-for="item in listIsVisitor" v-bind:value="item.value" v-bind:key="item.value">
                          {{item.text}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">NFCの有効</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isNFCValid">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">テンキーの有効・無効</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isTenKeyValid">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ゲートパスワードの有効・無効</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isGatePasswordValid" :disabled="gateInfor.isVisitor">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ゲートパスワードの桁数</div>
                    <div class="profile-info-value">
                      <select class="form-control" v-model="gateInfor.gatePasswordLength" :disabled="getEditStatus()">
                        <option v-for="item in listPassLenght" v-bind:value="item.value" v-bind:key="item.value">
                          {{item.text}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ゲートパスワードのseed値</div>
                    <div class="profile-info-value">
                      <span id="passwordseed_error" class="error_m"></span>
                      <input type="text" class="form-control input-sm" id="pseed" v-model="gateInfor.gatePasswordSeed" style="text-transform:uppercase" :disabled="getEditStatus()">
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">2段階認証の有効・無効</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isTwoStepAuthValid" :disabled="gateInfor.isVisitor">
                      <span class="lbl"></span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">BLE出力設定</div>
                    <div class="profile-info-value">
                      <select class="form-control" v-model="gateInfor.bleIntensity">
                        <option v-for="item in listBleIntensity" v-bind:value="item.value" v-bind:key="item.value">
                          {{item.text}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ブザー鳴動設定</div>
                    <div class="profile-info-value">
                      <select class="form-control" v-model="gateInfor.buzzerPattern">
                        <option v-for="item in listBuzzerPattern" v-bind:value="item.value" v-bind:key="item.value">
                          {{item.text}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                </div>
              </div>
              <div class="col-xs-6">
                <div class="row">
                <div class="profile-user-info profile-user-info-striped">
                  <div class="profile-info-row">
                    <div class="profile-info-name">備考.1</div>
                    <div class="profile-info-value">
                      <span id="option1_error" class="error_m"></span>
                      <textarea class="form-control" id="option1" placeholder="備考.1" v-model="gateInfor.option1"></textarea>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">備考.2</div>
                    <div class="profile-info-value">
                      <span id="option2_error" class="error_m"></span>
                      <textarea class="form-control" id="option1" placeholder="備考.2" v-model="gateInfor.option2"></textarea>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ゲート個体番号1</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.gateSNMain}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ゲート個体番号2</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.gateSNBLE}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">適用されているファームウェアバージョン（メインボード）</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.gateFWMain}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">適用されているファームウェアバージョン（BLE）</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.gateFWBLE}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">登録日</div>
                    <div class="profile-info-value">
                      <span>{{converDate(gateInfor.registered)}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">設定更新日</div>
                    <div class="profile-info-value">
                      <span>{{converDate(gateInfor.updated)}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ゲートへ設定情報を適用した日時</div>
                    <div class="profile-info-value">
                      <span>{{converDate(gateInfor.reported)}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">個人コード照合データー：最新リビジョン</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.revisionDesired}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">個人コード照合データー：ゲートへ設定済みのリビジョン</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.revisionReported}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">電池電圧</div>
                    <div class="profile-info-value">
                      <span>{{gateInfor.voltage}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">電池電圧更新日</div>
                    <div class="profile-info-value">
                      <span>{{converDate(gateInfor.scanDate)}}</span>
                    </div>
                  </div>
                  <div class="profile-info-row">
                    <div class="profile-info-name">ステータス</div>
                    <div class="profile-info-value">
                      <input name="switch-field-1" class="ace ace-switch ace-switch-4" type="checkbox" v-model="gateInfor.isValid">
                      <span class="lbl"></span>
                    </div>
                  </div>
                </div>
                </div>
              </div>
              </div>
              <div class="form-group">
                <div class="col-sm-12 text-align-right">
                  <router-link :to="{ name: 'gates'}" class="btn cancel_bottom">
                    キャンセル
                  </router-link>
                  <button class="btn btn-info save_group_bottom" type="button" @click="validateBeforeSubmit">
                    保存
                  </button>
                </div>
              </div>
              <div id="accordion" class="accordion-style1 panel-group">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <a class="accordion-toggle" data-toggle="collapse" href="#relation-gate">
                        <i class="bigger-110 ace-icon fa fa-angle-right" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
                        &nbsp;ゲートグループ
                      </a>
                    </h4>
                  </div>
                  <div class="panel-collapse collapse" id="relation-gate" aria-expanded="true">
                    <div class="panel-body">
                      <table style="min-width:100%" class="table table-striped table-bordered table-hover dataTable">
                        <thead>
                          <tr>
                            <th class="center" v-if="listGateGroup!=null" style="width:50px!important">
                              <label class="pos-rel">
                                <input type="checkbox" class="ace" v-model="selectAllGate">
                                <span class="lbl"></span>
                              </label>
                            </th>
                            <th>ゲートグループID</th>
                            <th>ゲートグループ名</th>
                            <th class="center">ステータス</th>
                          </tr>
                        </thead>
                        <tbody v-if="listGateGroup!=null">
                          <template v-for="(item, index) in listGateGroup">
                            <tr v-bind:class="{'selected': rowSelectedGate(item.relationId)}" :key="index">
                              <td class="center">
                                <label class="pos-rel">
                                  <input type="checkbox" class="ace" :value="item.relationId" v-model="selectedGateId">
                                  <span class="lbl"></span>
                                </label>
                              </td>
                              <td>{{item.groupId.groupId}}</td>
                              <td>{{item.groupId.name}}</td>
                              <td class="center"><span v-if="item.groupId.isValid">有効</span><span v-else >無効</span></td>
                            </tr>
                          </template>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="3">データーはありません</td>
                          </tr>
                        </tbody>
                      </table>
                      <button class="btn-cus btn-right btn-add" type="button" @click="addGroup(gateInfor.gateId)">
                      ゲートグループの関連付けを追加
                      </button>
                      <a class="btn-cus btn-right btn-delete" href="#processGate" data-toggle="modal" @click="resetStatus()">チェックしたゲートグループの関連付け解除</a>
                    </div>
                  </div>
                </div>
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <a class="accordion-toggle" data-toggle="collapse" href="#passage" aria-expanded="true">
                        <i class="ace-icon fa fa-angle-right bigger-110" data-icon-hide="ace-icon fa fa-angle-down" data-icon-show="ace-icon fa fa-angle-right"></i>
                        &nbsp;期限付きゲートを持つユーザー
                      </a>
                    </h4>
                  </div>
                  <div class="panel-collapse collapse" id="passage">
                    <div class="panel-body">
                      <table style="min-width:100%" class="table table-striped table-bordered table-hover dataTable">
                        <thead>
                          <tr>
                            <th class="center" v-if="listUserGroup != null" style="width:50px!important">
                              <label class="pos-rel">
                                <input type="checkbox" class="ace" v-model="selectAllUser">
                                <span class="lbl"></span>
                              </label>
                            </th>
                            <th>ユーザーID</th>
                            <th>ユーザー名</th>
                            <th>ふりがな</th>
                            <th class="center">ステータス</th>
                            <th class="center">開始日時</th>
                            <th class="center">終了日時</th>
                          </tr>
                        </thead>
                        <tbody v-if="listUserGroup != null">
                          <template v-for="(item, index) in listUserGroup">
                            <tr v-bind:class="{'selected': rowSelected(item.passageId)}" :key="index">
                              <td class="center">
                                <label class="pos-rel">
                                  <input type="checkbox" class="ace" :value="item.passageId" v-model="selectedUserId">
                                  <span class="lbl"></span>
                                </label>
                              </td>
                              <td>{{item.userId.userId}}</td>
                              <td>{{item.userId.name}}</td>
                              <td>{{item.userId.furigana}}</td>
                              <td class="center"><span v-if="item.userId.isValid">有効</span><span v-else >無効</span></td>
                              <td class="center">{{converDate(item.notBefore)}}</td>
                              <td class="center">{{converDate(item.notAfter)}}</td>
                            </tr>
                          </template>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="6">データーはありません</td>
                          </tr>
                        </tbody>
                      </table>
                      <button class="btn-cus btn-right btn-add" type="button" @click="addUser(gateInfor.gateId)">
                      ユーザーの関連付けを追加
                      </button>
                      <a class="btn-cus btn-right btn-delete" href="#process" data-toggle="modal" @click="resetStatus()">チェックしたユーザーの関連付け解除</a>
                    </div>
                  </div>
                </div>
              </div>
              </form>
              <!-- PAGE CONTENT ENDS -->
            </div><!-- /.col -->
          </div><!-- /.row -->
          </div>
        </div><!-- /.page-content -->
      </div>
    </div><!-- /.main-content -->
    <!-- プロフィールModal -->
    <div id="process" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 class="smaller lighter frofile-title no-margin">関連付け解除</h3>
          </div>
          <div class="modal-body">
            <span class="progress-question">このユーザーとの関連付けを解除しますか？</span>
            <div class="progress"  v-bind:class="{'progress-striped':!success , active:!success, hide:!success}">
              <div class="progress-bar" :style="progressWidth">
              <span>{{ Math.round(progress) }}%</span>
              </div>
            </div>
            <span class="success-label" v-if="successUser>0">{{countUser}}件中{{successUser}}件を解除しました。</span>
            <div v-if="errorMessage.length>0">
            <span class="error-box-title">解除失敗</span>
            <div class="error-box">
              <template v-for="item in errorMessage">
                <p v-html="item" :key="item"></p>
              </template>
            </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success">OK</button>
            <button class="btn btn-sm btn-danger pull-right" style="width:100px" v-if="!success" :disabled="isDisabled" @click="deleteRelationUser()">実行</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
    <div id="processGate" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 class="smaller lighter frofile-title no-margin">関連付け解除</h3>
          </div>
          <div class="modal-body">
            <span class="progress-question">このゲートとの関連付けを解除しますか？</span>
            <div class="progress"  v-bind:class="{'progress-striped':!success , active:!success, hide:!success}">
              <div class="progress-bar" :style="progressWidth">
              <span>{{ Math.round(progress) }}%</span>
              </div>
            </div>
            <span class="success-label" v-if="successGate>0">{{countGate}}件中{{successGate}}件を解除しました。</span>
            <div v-if="errorMessage.length>0">
            <span class="error-box-title">解除失敗</span>
            <div class="error-box">
              <template v-for="item in errorMessage">
                <p v-html="item" :key="item"></p>
              </template>
            </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success">OK</button>
            <button class="btn btn-sm btn-danger pull-right" style="width:100px" v-if="!success" :disabled="isDisabled" @click="deleteRelationGate()">実行</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'
import moment from 'moment'

export default {
  data () {
    return {
      currentTime: '',
      errorMessageLogs: '',
      selectedUserId: [],
      selectedGateId: [],
      listUserGroup: null,
      listGateGroup: null,
      listIconType: [
        { text: 'ドア', value: 1 },
        { text: 'ロッカー', value: 2 },
        { text: 'その他', value: 0 }

      ],
      listControlTime: [
        { text: '0000－9999 S', value: 0 },
        { text: '000.0-999.9 S', value: 1 },
        { text: '00.00-99.99 S', value: 2 },
        { text: '0.000-9.999 S', value: 3 }
      ],
      listIsVisitor: [
        { text: 'ビジター', value: true },
        { text: 'メンバー', value: false }
      ],
      listBuzzerPattern: [
        { text: 'OFF', value: 0 },
        { text: '鳴動パターン１', value: 1 },
        { text: '鳴動パターン２', value: 2 }
      ],
      listPassLenght: [
        { text: '5桁', value: 5 },
        { text: '6桁', value: 6 },
        { text: '7桁', value: 7 },
        { text: '8桁', value: 8 }
      ],
      listBleIntensity: [
        { text: '4dBm', value: 0 },
        { text: '0dBm', value: 1 },
        { text: '-4dBm', value: 2 },
        { text: '-8dBm', value: 3 },
        { text: '-12dBm', value: 4 },
        { text: '-16dBm', value: 5 },
        { text: '-20dBm', value: 6 },
        { text: '-40dBm', value: 7 }
      ],
      gateInfor: {
        gateId: '',
        gateModelCode: '',
        gateModelName: '',
        gateModelId: '',
        iconType: 0,
        makerCode: '',
        customizable: false,
        target: 0,
        controlTime: 0,
        timeUnit: 0,
        gateName: '',
        isVisitor: false,
        isNFCValid: false,
        isTenKeyValid: false,
        isGatePasswordValid: false,
        gatePasswordLength: 5,
        gatePasswordSeed: '',
        isTwoStepAuthValid: false,
        bleIntensity: 4,
        buzzerPattern: 1,
        option1: '',
        option2: '',
        gateSNMain: '',
        gateSNBLE: '',
        gateFWMain: '',
        gateFWBLE: '',
        registered: '',
        updated: '',
        reported: '',
        revisionDesired: '',
        revisionReported: '',
        voltage: '',
        scanDate: '',
        isValid: true
      },
      gateId: '',
      flag: 0,
      message_success: '',
      message_error: '',
      isDisabled: false,
      progress: 0,
      success: false,
      loading: false,
      errorMessage: [],
      successUser: 0,
      successGate: 0,
      errorName: '',
      countUser: 0,
      countGate: 0,
      listGateModel: null,
      exeCountGroup: 0,
      exeCountUser: 0,
      percent: 0
    }
  },
  watch: {
    'gateId': 'fetchData',
    'gateInfor.isVisitor': 'changeValue',
    'progress': 'checkProgress',
    exeCountGroup: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.countGate) {
        vm.deleteGroup(this.selectedGateId[newVal], vm.percent, newVal)
      } else if (newVal > 0 && newVal === vm.countGate) {
        vm.getInforGateGroup(this.gateId)
      }
    },
    exeCountUser: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.countUser) {
        vm.deleteGroupPassage(this.selectedUserId[newVal], vm.percent, newVal)
      } else if (newVal > 0 && newVal === vm.countUser) {
        vm.getInforGatePassage(vm.gateId)
      }
    }
  },
  created () {
    var vm = this
    vm.getGateData()
    vm.getListGateModel()
  },
  mounted () {
    var vm = this
    vm.currentTime = vm.converTimestamp(Date())
  },
  computed: {
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    },
    selectAllUser: {
      get: function () {
        return this.listUserGroup ? this.selectedUserId.length === this.listUserGroup.length : false
      },
      set: function (value) {
        var selectedUserId = []
        if (value) {
          this.listUserGroup.forEach(function (item) {
            selectedUserId.push(item.passageId)
          })
        }
        this.selectedUserId = selectedUserId
      }
    },
    selectAllGate: {
      get: function () {
        return this.listGateGroup ? this.selectedGateId.length === this.listGateGroup.length : false
      },
      set: function (value) {
        var selectedGateId = []
        if (value) {
          this.listGateGroup.forEach(function (item) {
            selectedGateId.push(item.relationId)
          })
        }
        this.selectedGateId = selectedGateId
      }
    }
  },
  methods: {
    converTimestamp (t) {
      return parseInt(new Date(t) / 1000)
    },
    changeValue () {
      if (this.gateInfor.isVisitor) {
        this.gateInfor.isGatePasswordValid = false
        this.gateInfor.isTwoStepAuthValid = false
      }
    },
    getEditStatus () {
      if (!this.gateInfor.isGatePasswordValid || this.gateInfor.isVisitor) {
        return true
      } else {
        return false
      }
    },
    validateBeforeSubmit () {
      this.flag = 0
      if (this.gateInfor.gateModelId === null || this.gateInfor.gateModelId === '') {
        $('#product_error').html('製品名は必須です。')
        $('#productname').addClass('error')
        this.flag += 1
      } else {
        $('#product_error').html('')
        $('#productname').removeClass('error')
      }
      if (this.gateInfor.gateName === null || this.gateInfor.gateName === '') {
        $('#gate_error').html('ゲート名は必須です。')
        $('#gatename').addClass('error')
        this.flag += 1
      } else if (this.gateInfor.gateName.length > 64) {
        $('#gate_error').html('ゲート名は64文字以内で入力してください。')
        $('#gatename').addClass('error')
        this.flag += 1
      } else {
        $('#gate_error').html('')
        $('#gatename').removeClass('error')
      }
      if (this.gateInfor.option1.length > 64) {
        $('#option1_error').html('備考.1は64文字以内で入力してください。')
        this.flag += 1
      } else {
        $('#option1_error').html('')
      }
      if (this.gateInfor.option2.length > 64) {
        $('#option2_error').html('備考.2は64文字以内で入力してください。')
        this.flag += 1
      } else {
        $('#option2_error').html('')
      }
      var isOk = /^[0-9A-F]+$/.test(this.gateInfor.gatePasswordSeed)
      if (!isOk || this.gateInfor.gatePasswordSeed.length > 18 || this.gateInfor.gatePasswordSeed.length < 18) {
        $('#passwordseed_error').html('半角英数（0～9、A〜F）で18文字入力してください。')
        $('#pseed').addClass('error')
        this.flag += 1
      } else {
        $('#passwordseed_error').html('')
        $('#pseed').removeClass('error')
      }
      if (this.flag === 0) {
        this.editInforGate()
      }
    },
    converDate (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD H:mm')
    },
    getListGateModel () {
      this.$http.get(Config.GATE_MODEL_LIST_API)
        .then(response => {
          console.log(response)
          this.listGateModel = response.body.gateModels
        })
        .catch((error) => {
          this.listGateModel = null
          console.log(error)
        })
    },
    checkProgress () {
      if (Math.round(this.progress) === 100) {
        this.success = true
        this.selectedUserId = []
        this.selectedGateId = []
      }
    },
    resetStatus () {
      $('.progress').addClass('hide')
      $('.progress-question').html('このユーザーとの関連付けを解除しますか？')
      this.progress = 0
      this.success = false
      this.isDisabled = false
      this.errorMessage = []
      this.successUser = 0
      this.successGate = 0
      this.countUser = 0
      this.countGate = 0
      this.exeCountUser = 0
      this.exeCountGroup = 0
    },
    rowSelected (userId) {
      if (jQuery.inArray(userId, this.selectedUserId) !== -1) {
        return true
      } else {
        return false
      }
    },
    rowSelectedGate (userId) {
      if (jQuery.inArray(userId, this.selectedGateId) !== -1) {
        return true
      } else {
        return false
      }
    },
    fetchData () {
      this.getInforGateGroup(this.gateId)
      this.getInforGatePassage(this.gateId)
    },
    getGroupInfo (groupId, gateId, i) {
      var vm = this
      this.$http.get(Config.GROUPS_LIST_API + '?groupId=' + encodeURIComponent(groupId))
        .then(response => {
          vm.listGateGroup[i].groupId = response.body.groups[0]
        })
        .catch(error => {
          console.log(error)
        })
    },
    getInforGateGroup (gateId) {
      var vm = this
      this.$http.get(Config.RELATION_GATE_GROUP_API + '?gateId=' + encodeURIComponent(gateId))
        .then(response => {
          vm.listGateGroup = response.body.relationsGateGroup
          if (vm.listGateGroup.length > 0) {
            for (var i = 0; i < vm.listGateGroup.length; i++) {
              vm.getGroupInfo(vm.listGateGroup[i].groupId, vm.listGateGroup[i].gateId, i)
            }
          } else {
            vm.listGateGroup = null
          }
        })
        .catch((error) => {
          vm.listGateGroup = null
          console.log(error)
        })
    },
    getInforUser (gateId, userId, i) {
      var vm = this
      this.$http.get(Config.USERS_LIST_API + '?userId=' + encodeURIComponent(userId))
        .then(response => {
          vm.listUserGroup[i].userId = response.body.users[0]
        })
        .catch(error => {
          console.log(error)
        })
    },
    getInforGatePassage (gateId) {
      var vm = this
      this.$http.get(Config.GATES_PASSAGE_API + '?gateId=' + encodeURIComponent(gateId) + '&notBefore=' + vm.currentTime)
        .then(response => {
          console.log(response)
          if (response.body.maxRecords > 0) {
            vm.listUserGroup = response.body.passages
            for (var i = 0; i < vm.listUserGroup.length; i++) {
              vm.getInforUser(vm.listUserGroup[i].gateId, vm.listUserGroup[i].userId, i)
            }
          } else {
            vm.listUserGroup = null
          }
        })
        .catch((error) => {
          console.log(error)
          vm.listUserGroup = null
        })
    },
    getGateData () {
      var vm = this
      vm.errorMessageLogs = ''
      var data = this.$route.query
      this.gateId = data.id
      this.$http.get(Config.GATES_LIST_API + '?gateId=' + encodeURIComponent(vm.gateId))
        .then(response => {
          console.log(response)
          vm.gateInfor.gateId = response.body.gates[0].gateId
          vm.gateInfor.gateModelCode = response.body.gates[0].gateModelCode
          vm.gateInfor.gateModelName = response.body.gates[0].gateModelName
          vm.gateInfor.gateModelId = response.body.gates[0].gateModelId
          vm.gateInfor.iconType = response.body.gates[0].iconType
          vm.gateInfor.makerCode = response.body.gates[0].makerCode
          vm.gateInfor.customizable = response.body.gates[0].customizable
          vm.gateInfor.target = response.body.gates[0].target
          vm.gateInfor.controlTime = response.body.gates[0].controlTime
          vm.gateInfor.timeUnit = response.body.gates[0].timeUnit
          vm.gateInfor.gateName = response.body.gates[0].gateName
          vm.gateInfor.isVisitor = response.body.gates[0].isVisitor
          vm.gateInfor.isNFCValid = response.body.gates[0].isNFCValid
          vm.gateInfor.isTenKeyValid = response.body.gates[0].isTenKeyValid
          vm.gateInfor.isGatePasswordValid = response.body.gates[0].isGatePasswordValid
          vm.gateInfor.gatePasswordLength = response.body.gates[0].gatePasswordLength
          vm.gateInfor.gatePasswordSeed = response.body.gates[0].gatePasswordSeed
          vm.gateInfor.isTwoStepAuthValid = response.body.gates[0].isTwoStepAuthValid
          vm.gateInfor.bleIntensity = response.body.gates[0].bleIntensity
          vm.gateInfor.buzzerPattern = response.body.gates[0].buzzerPattern
          vm.gateInfor.option1 = response.body.gates[0].option1
          vm.gateInfor.option2 = response.body.gates[0].option2
          vm.gateInfor.gateSNMain = response.body.gates[0].gateSNMain
          vm.gateInfor.gateSNBLE = response.body.gates[0].gateSNBLE
          vm.gateInfor.gateFWMain = response.body.gates[0].gateFWMain
          vm.gateInfor.gateFWBLE = response.body.gates[0].gateFWBLE
          vm.gateInfor.registered = response.body.gates[0].registered
          vm.gateInfor.updated = response.body.gates[0].updated
          vm.gateInfor.reported = response.body.gates[0].reported
          vm.gateInfor.revisionDesired = response.body.gates[0].revisionDesired
          vm.gateInfor.revisionReported = response.body.gates[0].revisionReported
          vm.gateInfor.voltage = response.body.gates[0].voltage
          vm.gateInfor.scanDate = response.body.gates[0].scanDate
          vm.gateInfor.isValid = response.body.gates[0].isValid
        })
        .catch(error => {
          switch (error.status) {
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = 'ゲートの取得権限がありません。'
              break
            case 404:
              this.errorMessageLogs = '該当するデーターがありません。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    },
    getGateModelInforWithGateModeId (gateModelId) {
      var vm = this
      vm.listGateModel.forEach(function (item) {
        if (item.gateModelId === gateModelId) {
          vm.gateInfor.gateModelCode = item.gateModelCode
          vm.gateInfor.gateModelName = item.gateModelName
          vm.gateInfor.controlTime = item.controlTime
          vm.gateInfor.makerCode = item.makerCode
          vm.gateInfor.customizable = item.customizable
          vm.gateInfor.iconType = item.iconType
          vm.gateInfor.target = item.target
          vm.gateInfor.timeUnit = item.timeUnit
        }
      })
    },
    editInforGate () {
      var vm = this
      vm.loading = true
      const Infor = {
        gateName: vm.gateInfor.gateName,
        gateModelId: vm.gateInfor.gateModelId,
        gateModelName: vm.gateInfor.gateModelName,
        gateModelCode: vm.gateInfor.gateModelCode,
        iconType: vm.gateInfor.iconType,
        customizable: vm.gateInfor.customizable,
        makerCode: vm.gateInfor.makerCode,
        target: vm.gateInfor.target,
        timeUnit: vm.gateInfor.timeUnit,
        controlTime: parseInt(vm.gateInfor.controlTime),
        isVisitor: vm.gateInfor.isVisitor,
        isNFCValid: vm.gateInfor.isNFCValid,
        isTenKeyValid: vm.gateInfor.isTenKeyValid,
        isGatePasswordValid: vm.gateInfor.isGatePasswordValid,
        gatePasswordLength: vm.gateInfor.gatePasswordLength,
        gatePasswordSeed: vm.gateInfor.gatePasswordSeed,
        isTwoStepAuthValid: vm.gateInfor.isTwoStepAuthValid,
        bleIntensity: vm.gateInfor.bleIntensity,
        buzzerPattern: vm.gateInfor.buzzerPattern,
        option1: vm.gateInfor.option1,
        option2: vm.gateInfor.option2,
        isValid: vm.gateInfor.isValid
      }
      console.log(Infor)
      this.$http.put(Config.GATES_LIST_API + '/' + encodeURIComponent(vm.gateId), Infor)
        .then(response => {
          this.loading = false
          window.scrollTo(0, 0)
          this.message_success = Config.EDIT_GATE_API_SUCCESS
          this.errorMessageLogs = ''
          this.message_error = ''
        })
        .catch((error) => {
          this.loading = false
          this.message_success = ''
          switch (error.status) {
            case 400:
              this.message_error = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.message_error = 'ゲートの編集権限がありません。'
              break
            case 404:
              this.message_error = '該当するデーターがありません。'
              break
            case 409:
              this.message_error = '入力されたゲート名は既に使用されています。他のゲート名を入力してください。'
              break
            case 500:
              this.message_error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.message_error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.message_error = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
        })
    },
    addGroup (gateId) {
      this.$router.push({name: 'gategroupadd', query: { id: gateId }})
    },
    addUser (gateId) {
      this.$router.push({name: 'gateuseradd', query: { id: gateId }})
    },
    deleteGroupPassage (passageId, percent, i) {
      var vm = this
      this.$http.delete(Config.GATES_PASSAGE_API + '/' + encodeURIComponent(passageId))
        .then(response => {
          vm.progress += percent
          vm.successUser += 1
          vm.exeCountUser++
        })
        .catch((error) => {
          vm.getInforGatePassage(vm.gateId)
          vm.progress += percent
          switch (error.status) {
            case 403:
              this.errorName = '期間指定の通行権限の削除権限がありません。'
              break
            case 404:
              this.errorName = '該当するデーターがありません。'
              break
            case 500:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
          var rowstatus = passageId + '>><span>' + this.errorName + '</span>'
          this.$set(this.errorMessage, i, rowstatus)
          this.exeCountUser++
        })
    },
    deleteRelationUser () {
      var vm = this
      vm.isDisabled = true
      if (this.selectedUserId.length > 0) {
        this.countUser = this.selectedUserId.length
        $('.progress').removeClass('hide')
        $('.progress-question').html('処理状況')
        vm.percent = (100 / this.selectedUserId.length)
        vm.deleteGroupPassage(this.selectedUserId[0], vm.percent, 0)
      } else {
        alert('少なくてもユーザーを１つ選んでください。')
      }
    },
    deleteGroup (relationId, percent, i) {
      this.$http.delete(Config.RELATION_GATE_GROUP_API + '/' + encodeURIComponent(relationId))
        .then(response => {
          this.progress += percent
          this.successGate += 1
          this.exeCountGroup++
        })
        .catch((error) => {
          this.getInforGateGroup(this.gateId)
          this.progress += percent
          switch (error.status) {
            case 403:
              this.errorName = 'ゲート通行権限の削除権限がありません。'
              break
            case 404:
              this.errorName = '該当するデーターがありません。'
              break
            case 500:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
          }
          var rowstatus = relationId + '>><span>' + this.errorName + '</span>'
          this.$set(this.errorMessage, i, rowstatus)
          this.exeCountGroup++
        })
    },
    deleteRelationGate () {
      var vm = this
      vm.isDisabled = true
      if (this.selectedGateId.length > 0) {
        this.countGate = this.selectedGateId.length
        $('.progress').removeClass('hide')
        $('.progress-question').html('処理状況')
        vm.percent = (100 / this.selectedGateId.length)
        vm.deleteGroup(this.selectedGateId[0], vm.percent, 0)
      } else {
        alert('少なくてもゲートを１つ選んでください。')
      }
    }
  }
}
</script>
<style>
.detail-gate-edit .profile-info-name{
  width: 400px
}
.float-left{
    float: left;
    padding-left: 12px
  }
  .btn-cus{
    padding: 10px 15px;
    color: #fff
  }
  .btn-right{
    float: right;
  }
  .btn-add,.btn-add:hover{
    background: #007F41
  }
  a.btn-delete,a.btn-delete:hover{
    background: #000!important;
    border-color: #000!important;
    color: #fff!important;
    margin-right: 10px;
    text-decoration: none;
  }
  .form-horizontal .control-label{
    margin-top: 0px
  }
  .col-custom{
    padding-right: 0px!important;
  }
  .iValid{
    padding-top: 2px!important;
  }
  input[type=checkbox].ace.ace-switch+.lbl::before{
    text-indent: 25px!important;
    content: "無効"!important;
  }
  input[type=checkbox].ace.ace-switch:checked+.lbl::before{
    text-indent: 5px!important;
    content: "有効"!important;
  }
  .message{
    position: absolute;
  }
  .form-horizontal .control-label{
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/views/gate/GateEdit.vue